import { useState, useEffect } from "react";
import { Card, Stack, Typography, Switch, TextField, InputAdornment, IconButton, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { toggleVisibility, setSearchQuery } from "Redux/streetsSlice";

export default function StreetsMenu() {
  const dispatch = useAppDispatch();
  const { visible, searchQuery } = useAppSelector((state) => state.streets);

  const [inputValue, setInputValue] = useState(searchQuery);

  useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  const handleToggle = () => {
    dispatch(toggleVisibility());
  };

  const handleSearch = () => {
    dispatch(setSearchQuery(inputValue.trim()));
  };

  const handleClear = () => {
    setInputValue("");
    dispatch(setSearchQuery(""));
  };

  return (
    <Card sx={{ p: 1.5, minWidth: "250px" }}>
      <Stack spacing={2}>
        <Stack direction="row" style={{ alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={{ fontSize: "15px !important", mb: "0 !important" }}>نمایش معابر روی نقشه</Typography>
          <Switch inputProps={{ "aria-label": "Switch streets" }} onChange={handleToggle} checked={visible} />
        </Stack>

        <Divider />

        <TextField
          size="small"
          placeholder="جستجوی نام خیابان..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch(); // سرچ با زدن دکمه اینتر
          }}
          disabled={!visible} // اگه لایه خاموشه، سرچ هم غیرفعال باشه بهتره
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {inputValue && (
                  <IconButton size="small" onClick={handleClear}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
                <IconButton size="small" onClick={handleSearch} disabled={!inputValue || !visible}>
                  <SearchIcon fontSize="small" color={inputValue ? "primary" : "inherit"} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </Card>
  );
}
